import React, { useEffect, useState } from 'react';
import '../my works/css/styles.css';
import GitHubMark from "../my works/Images/GitHub-Mark/PNG/GitHub-Mark-120px-plus.png";
import ViewIcon from "../my works/Images/view.png";
import DownloadIcon from "../my works/Images/download.png";
import { Link } from 'react-router-dom';
import Footer from '../components/footer'

const AppWork = (props) => {
  return(
    <>
    <div className="appContainer">
    <h3 classname="appName">{props.name}</h3>
    <p classname="appDescription">{props.description}</p>

    <center> <div className="appActionsContainer">
      <img onClick={()=>{window.location = props.github }} classname="icon" src={GitHubMark} style={{height:25,width:25}} />
      <img onClick={()=>{window.location = props.view}} classname="icon" src={ViewIcon} style={{height:25,width:25,}} />
        <img onClick={()=>{window.location = props.download}} classname="icon" src={DownloadIcon} style={{height:25,width:25,}} /></div></center>
    
      </div>
      <br /><br /><br />
      </>
  )
}

const AppWorkNoView = (props) => {
  return(
    <>
    <div className="appContainer" >
    <h3 classname="appName">{props.name}</h3>
    <p classname="appDescription">{props.description}</p>

    <center> <div className="appActionsContainer">
      <img onClick={()=>{window.location = props.github }} classname="icon" src={GitHubMark} style={{height:25,width:25}} />
        <img onClick={()=>{window.location = props.download}} classname="icon" src={DownloadIcon} style={{height:25,width:25,}} />
        </div></center>
      </div>
      <br /><br /><br />
      </>
  )
}



const MyWorks = () =>{ 
    return ( 
        <>
<p style={{fontSize:'10px'}}>Note: These are those works and projects which I made to do practice when I was a beginner. Meanwhile, it is also possible that you may find bugs and isues in some project</p>

<br />
<br />
<br />
<div style={{padding:20}}>
       <AppWork name="Food Panda Clone" github="https://github.com/Sharjeelbaig/foodPandaClone" view="https://sharjeelbaig-6fca7.web.app/my%20works/food%20panda%20clone/index.html" download="https://sharjeelbaig-6fca7.web.app/my%20works/food%20panda%20clone/download.html" description="a simple of starting page of food panda, made for practice" />
       <AppWork name="Simple Calculator" description="A simple Calculator made using js css html" github="https://github.com/Sharjeelbaig/Simple-Calculator"  view="https://sharjeelbaig-6fca7.web.app/my%20works/simple%20calculator/index.html" download="https://sharjeelbaig-6fca7.web.app/my%20works/simple%20calculator/download.html" />
       <AppWorkNoView name="Consulator" description="C# Calculator Console app" github="https://github.com/Sharjeelbaig/Consolulator"  download="https://sharjeelbaig-6fca7.web.app/my%20works/consolulator/download.html" />
       <AppWorkNoView name="Quadratic Equation solver" description="C# Quadratic Equation Solver Console app" github="https://github.com/Sharjeelbaig/Quadratic-Equation-Solver"  download="https://sharjeelbaig-6fca7.web.app/my%20works/quadratic%20equation%20solver/download.html" />
          </div>
    <br />
    <br />
    <br />
    <Footer />
   </>
        
     );

    }

 /*onclick={()=>{window.location.href = 'https://github.com/Sharjeelbaig/foodPandaClone'}}*/
export default MyWorks ;